import { Box, Grid, Typography, Theme, useTheme } from '@mui/material';
import { SubHeading } from '../investors/components';
import React from 'react';
import { Item, ItemDetails, Gridstyles } from './index';
import { Applicant } from '../../redux-store/types/api-types';
import { formatShortDate } from '../../utils/date';
import { SxProps } from '@mui/system';
import { personLDetailsStatusMasters } from '../../utils/constant';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { getUniqueIdentityText, isOnboardingTypeMinor,getModeOfHoldingDisplay } from '../../utils/utilityFunctions';

export const KeyValue = ({
  title,
  description,
  amount,
  sx = {},
}: {
  title: string | undefined;
  description?: string | number | boolean | null;
  amount?: number | null | undefined | string;
  sx?: SxProps<Theme>;
}): JSX.Element => {
  return (
    <Grid item xs={12} sm={6}>
      <Item sx={(theme: Theme) => ({
        ...theme.typography.body_500, lineHeight: '20px', letterSpacing: '0.02px', color: theme.palette.text.secondary, pb: '7px'
      })}>{title}</Item>
      <ItemDetails sx={(theme: Theme) => ({
        color: theme.palette.text.primary, textTransform: 'capitalize', fontWeight: '500', ...theme.typography.body_500
      })}> {description ? description : '-'}</ItemDetails>
      {!!amount && amount !== 0 && <Item sx={{ pt: 0 }}> {amount}</Item>}
    </Grid>
  );
};

export default function PersonalDetails({
  applicants = [],
  modeOfHolding,
}: {
  applicants: Partial<Applicant>[];
  modeOfHolding: string;
}): JSX.Element {
  const theme = useTheme();
  const { application } = useSelector((store: RootStateType) => store.application);
  const { company = "WMS" } = useSelector((state: RootStateType) => state.navbarInfo)

  return (
    <>
      <Box
        sx={(theme: Theme) => ({
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
          borderRadius: '10px',
          border: `1px solid ${theme.palette.grey[100]}`,
          padding: '25px',
        })}
        mt={5}
      >
        <Box>
          <Grid container >
            <Grid item xs={12} >
              <Typography sx={(theme: Theme) => ({ fontSize: 18, fontWeight: 700, color: theme.palette.primary[900], mb: '25px' })}>
                Personal Details
              </Typography>

            </Grid>
            <Grid item xs={12}>
              <Typography variant='body_500'
                sx={{
                  color: 'text.secondary',
                }}>
                Mode of Holding
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant='body_500'
                sx={{
                  color: 'text.primary',
                  textTransform: 'capitalize',
                }}>
                {getModeOfHoldingDisplay(modeOfHolding) ?? '-'}
              </Typography>
            </Grid>
            {applicants.map((applicant, index: number) => {
              const title = [
                'First Applicant Details',
                'Second Applicant Details',
                'Third Applicant Details',
              ][index];
              return (
                <React.Fragment key={applicant.id}>
                  <SubHeading
                    sx={{
                      letterSpacing: '0.02px',

                    }}>
                    {isOnboardingTypeMinor(application?.onboardingType || '')
                      ? 'Personal Details of Guardian'
                      : title}
                  </SubHeading>
                  {/* <Gridstyles> */}
                  <Grid
                    item
                    container
                    // pb={5}
                    rowSpacing={3}
                    columnSpacing={5.5}
                    direction="row"
                  // justifyContent="space-between"
                  // alignItems="flex-start"
                  >
                    <KeyValue title={'Full Name*'} description={`${applicant.namePrefix ?? ''} ${applicant.name}`} />
                    <KeyValue
                      title={'Father/Spouse Name*'}
                      description={applicant.fatherOrSpouseName}
                    />
                    <KeyValue title={'Name'} description={applicant.firstName} />
                    <KeyValue title={'Last Name'} description={applicant.lastName} />
                    <KeyValue title={`${getUniqueIdentityText(company)?.pan}*`} description={applicant.panNo} />
                    <KeyValue title={'Marital Status'} description={applicant.maritalStatus || '-'} />
                    <KeyValue title={'Gender*'} description={applicant.gender} />
                    {/* <KeyValue
                      title={'Occupation Type'}
                      description={applicant.occupationDetails}
                    /> */}
                    <KeyValue
                      title={'Status*'}
                      description={
                        applicant.status
                          ? personLDetailsStatusMasters[applicant.status]
                          : applicant.status
                      }
                    />
                    <KeyValue title={'Date of Birth*'} description={applicant?.dateOfBirth ? formatShortDate(applicant.dateOfBirth) : "-"} />
                    <KeyValue title={'Mother’s Maiden Name'} description={applicant.mothersMaiden || '-'} />
                    <KeyValue title={'Citizenship*'} description={applicant.citizenship || '-'} />
                    {index !== 0 && (
                      <KeyValue
                        title={'Relationship With First Applicant'}
                        description={applicant.relationShipWithFirstApplicant}
                      />
                    )}
                  </Grid>
                  {/* </Gridstyles> */}
                  {isOnboardingTypeMinor(application?.onboardingType || '') && (
                    <>
                      <SubHeading
                        sx={{
                          color: 'common.black',
                          letterSpacing: 0.5 + 'px',
                          padding: { xs: '10px 10px', sm: '10px 30px' },
                        }}>
                        Personal Details of Minor Applicant
                      </SubHeading>
                      <Gridstyles>
                        <Grid
                          item
                          container
                          pb={5}
                          rowSpacing={6}
                          columnSpacing={13}
                          direction="row"
                          justifyContent="space-between"
                          alignItems="flex-start">
                          <KeyValue title={`${getUniqueIdentityText(company)?.pan}`} description={applicant.minorPan} />
                          <KeyValue
                            title={'Date of Birth*'}
                            description={formatShortDate(applicant.minorDOB)}
                          />
                          {/* <KeyValue title={'Full Name'} description={applicant.minorName} /> */}
                          <KeyValue
                            title={'Name*'}
                            description={applicant.minorNamePrefix + ' ' + applicant.minorFirstName}
                          />
                          <KeyValue title={'Last Name'} description={applicant.minorLastName} />
                          <KeyValue title={'Father Name'} description={applicant.minorFatherName||"-"} />
                          <KeyValue title={'Gender*'} description={applicant.minorGender} />
                          <KeyValue title={'Email'} description={applicant.minorEmail} />
                          <KeyValue title={'Mobile Number'} description={applicant.minorMobile ?
                            (applicant.minorCountryCode
                              ? applicant.minorCountryCode + '-' + applicant.minorMobile
                              : applicant.minorMobile) : '-'
                          } />
                          <KeyValue
                            title={'Relationship with Guardian*'}
                            description={applicant.guardianRelationship}
                          />
                        </Grid>
                      </Gridstyles>
                    </>
                  )}
                </React.Fragment>
              );
            })}
          </Grid>
        </Box>
      </Box >
    </>
  );
}
